"use strict";
(self["webpackChunktom_bihn"] = self["webpackChunktom_bihn"] || []).push([[1586],{

/***/ 1586:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ slideCart)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9755);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);


function slideCart() {
  const urls = {
    cartUpdate: '/cart/update.js',
    cartChange: '/cart/change.js',
    cartAdd: '/cart/add.js',
    cartGet: '/cart.json',
  }

  const settings = {
    slideCartContainer: '.js-cart--container',
    slideCartInner: '.js-cart--inner',
    closeCart: '.js-cart--close',
    openCart: '[data-toggle-cart]',
    removeItem: '.js-cart--remove-item',
    itemQuantity: '.js-item-quantity',
    productForm: "form[action='/cart/add']",
    cartCount: '.js-cart-count',
    cartNoteTextarea: '.js-cart-note-textarea',
    cartNoteContainer: '.js-cart-note-container',
    cartNoteToggle: '.js-cart-note-toggle',
    removeNote: '.js-remove-note',
    checkoutButton: '.js-process-checkout',
    overlay: '.js-overlay',
  }

  let $elementToFocusOnClose = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.openCart)

  const init = function () {
    if (!jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.slideCartContainer).length) return

    initializeEventListeners()
    buildCart()
  }

  const initializeEventListeners = function () {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.slideCartContainer).on('click', settings.removeItem, handleItemRemove)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.slideCartContainer).on('click', settings.checkoutButton, processCheckout)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.slideCartContainer).on('change', settings.itemQuantity, adjustItemQuantity)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.slideCartContainer).on('change', settings.cartNoteTextarea, updateCartNote)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.slideCartContainer).on('click', settings.removeNote, removeCartNote)

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('submit', settings.productForm, handleProductSubmit)

    if (location.pathname !== '/cart') {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('click', settings.openCart, toggleCart)
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('click', settings.overlay + ', ' + settings.closeCart, closeCart)
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.slideCartContainer).on('keydown', cycleFocusableCartElements)
    }
  }

  const cycleFocusableCartElements = function (e) {
    let firstFocusableElement = jquery__WEBPACK_IMPORTED_MODULE_0___default()('.js-close-cart-x')
    let lastFocusableElement

    if (jquery__WEBPACK_IMPORTED_MODULE_0___default()('.js-ajax-no-items-bottom-btn').length) {
      lastFocusableElement = jquery__WEBPACK_IMPORTED_MODULE_0___default()('.js-ajax-no-items-bottom-btn')
    } else {
      lastFocusableElement = jquery__WEBPACK_IMPORTED_MODULE_0___default()('.js-ajax-some-items-bottom-btn')
    }

    if (e.target == firstFocusableElement[0] && e.key == 'Tab' && e.shiftKey) {
      e.preventDefault()
      lastFocusableElement.focus()
    } else if (e.target == lastFocusableElement[0] && e.key == 'Tab' && !e.shiftKey) {
      e.preventDefault()
      firstFocusableElement.focus()
    }

    if (e.keyCode === 27) {
      closeCart(e)
    }
  }

  const processCheckout = function (e) {
    location.href = '/checkout'
  }

  const processCartRequest = function (data, endpoint, callback) {
    var params = {
      url: endpoint,
      data: data,
      method: 'POST',
      dataType: 'json',
      success: function (cart) {
        if (callback) {
          callback(cart)
        } else {
          buildCart()
        }
      },
      error: function (err) {
        console.warn(err)
      },
    }

    jquery__WEBPACK_IMPORTED_MODULE_0___default().ajax(params)
  }

  const removeCartNote = function () {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.cartNoteTextarea).val('').change()
  }

  const updateCartNote = function (e) {
    let $this = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this)
    let value = $this.val()

    let data = {
      note: value,
    }

    processCartRequest(data, urls.cartUpdate, function () {})
  }

  const adjustItemQuantity = function (e) {
    let $this = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this)
    let key = $this.data('key')

    let data = {
      updates: {
        [key]: $this.val(),
      },
    }

    processCartRequest(data, urls.cartUpdate, function () {
      buildCart()
    })
  }

  const updateItemQuantity = function (e) {
    let quantity = parseInt(jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).data('quantity'))

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).siblings(settings.itemQuantity).val(quantity).trigger('change')
  }

  const handleProductSubmit = function (e) {
    e.preventDefault()

    var $self = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this)
    let quantity = $self.find('.js-quantityInput').val()
    let idInputs = $self.find('[name="id"]')
    let id = idInputs.val()
    if (idInputs.length > 1) {
      id = idInputs.filter(':checked').val()
    }
    var variantName = $self.find('[name="id"] option:selected').text()
    let isCartUpsell = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).data('cartUpsell')
    let properties = {}

    const propertyInputs = $self.find('[name*="properties"]');

    propertyInputs.each(function (index, input) {
      // if input value is empty or if the input is disabled skip
      // otherwise, add to properties object in key value pair
      const inputVal = jquery__WEBPACK_IMPORTED_MODULE_0___default()(input).val();
      const isDisabled = jquery__WEBPACK_IMPORTED_MODULE_0___default()(input).is(':disabled')
      const inputName = jquery__WEBPACK_IMPORTED_MODULE_0___default()(input).prop('name').replace('properties[', '').replace(']', '')

      if (!isDisabled && !!inputVal) {
        properties[inputName] = inputVal
      }
    })

    var items = [
      {
        quantity: quantity,
        id: id,
        properties: properties
      },
    ]

    if (!isCartUpsell) {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()('.js-add-on').each((index, el) => {
        if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(el).is('[type=checkbox]') && jquery__WEBPACK_IMPORTED_MODULE_0___default()(el).prop('checked') == false) {
          return
        }

        var value = jquery__WEBPACK_IMPORTED_MODULE_0___default()(el).val()

        if (value) {
          var item = {
            id: value,
            quantity: quantity,
            properties: {
              'Bundled With': $self.attr('data-productname') + ' - ' + variantName,
              _bundleId: id,
            },
          }

          items.push(item)
        }
      })
    }

    var data = {
      items: items,
    }

    processCartRequest(data, urls.cartAdd, () => {
      buildCart()

      if (!isCartUpsell) {
        toggleCart()
      }
    })
  }

  const handleItemRemove = function (e) {
    let $this = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this)
    let key = $this.data('key')

    let data = {
      updates: {
        [key]: 0,
      },
    }

    processCartRequest(data, urls.cartUpdate, function () {
      buildCart()
    })
  }

  const getCart = function (callback) {
    jquery__WEBPACK_IMPORTED_MODULE_0___default().ajax(urls.cartGet).then(callback)
  }

  const buildCart = function (sectionsToRender = ['header', 'items', 'upsell', 'notes', 'footer']) {
    getCart(function (cart) {
      const sectionID = 'ajax-cart'
      let pathname = location.pathname === '/cart' ? '/cart' : ''

      jquery__WEBPACK_IMPORTED_MODULE_0___default().ajax(`${pathname}/?sections=${sectionID}`)
        .then(function (response) {
          if (response[sectionID]) {
            let $response = jquery__WEBPACK_IMPORTED_MODULE_0___default()(response[sectionID])
            let $newInnerHTML = $response.find(settings.slideCartInner)

            if (cart.item_count > 0 && jquery__WEBPACK_IMPORTED_MODULE_0___default()('.js-slide-cart--items').length) {
              sectionsToRender.forEach(function (section) {
                let $sectionEl = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.slideCartContainer).find(`.js-slide-cart--${section}`)
                let $newEl = $newInnerHTML.find(`.js-slide-cart--${section}`)
                $sectionEl.replaceWith($newEl)
              })
            } else {
              jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.slideCartContainer).html($newInnerHTML)
            }

            //update nav cart count
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.cartCount)
              .text(cart.item_count)
              .toggleClass('hidden', cart.item_count == 0)
          }
        })
        .catch(function () {})
    })
  }

  const toggleCart = function (e) {
    if (e) e.preventDefault()

    let $elementToFocus = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this)

    const $triggers = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-toggle-cart]')

    $triggers.toggleClass('active')

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.slideCartContainer).toggleClass('active')

    const isOpen = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.slideCartContainer).hasClass('active')

    if (!isOpen) {
      $elementToFocus = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.closeCart)

      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.overlay).removeClass(['active', 'cart-overlay'])
      removeNoScroll()
      setTimeout(function () {
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.slideCartContainer).css('visibility', 'hidden')
      }, 500)
    } else {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.overlay).css({
        top: 0,
      })
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.overlay).addClass(['active', 'cart-overlay'])
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.slideCartContainer).css('visibility', 'visible')
      addNoScroll()
    }

    $elementToFocus.trigger('focus')
  }

  const closeCart = function (e) {
    if (e) {
      e.preventDefault()
    }

    let $cartContainer = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.slideCartContainer)
    $cartContainer.removeClass('active')

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.overlay).removeClass(['active', 'cart-overlay'])
    removeNoScroll()

    setTimeout(function () {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.slideCartContainer).css('visibility', 'hidden')
    }, 500)

    setTimeout(function () {
      // $cartContainer.hide()

      if ($elementToFocusOnClose && $elementToFocusOnClose.length) {
        $elementToFocusOnClose.focus()
      }
    }, 600)
  }
  init()
}


/***/ })

}]);